// Packages and components
import React from 'react';
import { Heading } from 'grommet';

// Helpers and utilities
import { toSentenceCase } from '@theme-utils/type';

// Types
import type { SHDHeadingProps } from './SHDHeading.d';

const SHDHeading: React.FC<SHDHeadingProps> = ({
  className = 'heading',
  children,
  formatCasing = true,
  ...props
}) => {
  const level = props.level || 1;
  return (
    <Heading
      className={`${className} h${level}`}
      level={level}
      margin="0"
      {...props}
    >
      {formatCasing ? toSentenceCase(children) : children}
    </Heading>
  );
};

export default SHDHeading;
